module.exports = __webpack_public_path__ + "static/media/businessapps.3adec54d.png";